export default () => ({
  beenUpdated: false,
  wasRaised: false,
  show: false,
  speciality: {
    attachment: {
      content: null,
      mime: null
    },
    speciality_id: null,
    rqe: null
  },
  includes: ['professional', 'speciality'],
  optionsSpecialities: [],
  nextStepButtonIsProfessionalSpeciality: [
    {
      icon: '',
      text: 'Especialidades Médicas',
      name: 'professional.record.specialities.create',
      action: true
    },
    {
      icon: '',
      text: 'Cadastro de Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/form/resources/data.js